export default "__VITE_ASSET__9af2e3ce__"